import React, { useState, useEffect } from 'react';
import './placements.css';
import C2wButton from '../../../common/global/button';
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { Autoplay, Navigation, Pagination } from 'swiper/modules';
import placementData from '../../../pages/c2wHomePage/placements/placements.json'
import { Swiper, SwiperSlide } from 'swiper/react';
import { useNavigate } from 'react-router';

function C2wPlacements() {

  const navigate = useNavigate()
    /**
 * @function getSlidesPerView
 * @author Vishal Lohbande
 *
 * Description:
 * - Calculates and returns the number of slides to show based on the current window width.
 * - Supports responsive behavior by adjusting slides per view for different screen sizes.
 *
 * Behavior:
 * - Uses `window.innerWidth` to get the viewport width.
 * - Returns different numeric values representing slides count or partial slides for breakpoints:
 *   - ≤ 480px: 1 slide
 *   - ≤ 768px: 1.8 slides
 *   - ≤ 1024px: 2.5 slides
 *   - ≤ 1300px: 3.3 slides
 *   - ≤ 1500px: 3.5 slides
 *   - ≤ 1750px: 3.8 slides
 *   - Above 1750px: 4 slides (default maximum)
 *
 * Usage:
 * - Commonly used in carousel or slider components to control how many slides are visible.
 * - Enables smooth responsive design adapting to various device widths.
 *
 * Notes:
 * - Fractional values (e.g., 1.8, 2.5) allow showing partial slides for better visual flow.
 * - Adjust breakpoints and values as needed to match design requirements.
 */
    const getSlidesPerView = () => {
        const width = window.innerWidth;
        if (width <= 480) return 1;
        if (width <= 768) return 1.8;
        if (width <= 1024) return 2.5;
        if (width <= 1300) return 3.3;
        if (width <= 1500) return 3.5;
        if (width <= 1750) return 3.8;
        return 4;
      };

    /**
 * @state slidesPerView
 * @hook useEffect - Responsive Slides Per View Update
 * @author Vishal Lohbande
 *
 * Description:
 * - Initializes `slidesPerView` state with the current number of slides to show,
 *   based on the window width by calling `getSlidesPerView()`.
 * - Sets up a window resize event listener to update `slidesPerView` dynamically when
 *   the browser window is resized.
 *
 * Behavior:
 * - `handleResize` callback recalculates the slides per view and updates the state.
 * - Event listener is added on mount and removed cleanly on unmount to avoid memory leaks.
 *
 * Use Case:
 * - Enables responsive carousels or sliders to adjust visible slides on different screen sizes.
 *
 * Notes:
 * - The initial state value is calculated once when the component mounts.
 * - The resize listener ensures the UI adapts in real-time to window size changes.
 */
    const [slidesPerView, setSlidesPerView] = useState(getSlidesPerView());
    useEffect(() => {
      const handleResize = () => setSlidesPerView(getSlidesPerView());
      window.addEventListener('resize', handleResize);
      return () => window.removeEventListener('resize', handleResize);
    }, []);
    

  return (
    <div className='C2wPlacements_ctn'>
      {/* <div className='C2wPlacementsHomeHeading_ctn_hld'>
        <div className='C2wPlacements_heading'>
          {'Our '}
          <span className='C2wPlacementsHeadingSpan'>{'Top placements'}</span>
        </div>
      </div> */}

      <div className='ADOurfruitsoutersliderholder' id='testimonials-swiper'>
        {placementData?.placements?.length > 0 && (
          <Swiper
          modules={[Autoplay]}
            slidesPerView={getSlidesPerView()}
            loop={placementData?.placements?.length > 1}
            centeredSlides={true}
            speed={1200}
            autoplay={{
              delay: 3000,
              disableOnInteraction: false,
            }}
            pagination={{ clickable: true }}
            className='myPlacementsSwiper'
          >
            {placementData?.placements?.slice(0, 10).map((item, index) => (
              <SwiperSlide key={index}>
                <div className='slidercards'>
                  <img src={`/assets/images/placements/${item}`} alt='' loading='lazy' />
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        )}
      </div>
       <button className="C2wCoursesExploreBtn" onClick={() => {
                    navigate('/placements')
                }}>
                    <span className="buttonText">All Placements</span>

                    {/* Sliding Background with Hover Arrow */}
                    <div className="AnimatedButton">
                        <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M9 12H23"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M16 5L23 12L16 19"
                                stroke="white"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </div>

                    {/* Default Arrow */}
                    <svg
                        className="defaultArrow"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M9 12H23"
                            stroke="#fff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M16 5L23 12L16 19"
                            stroke="#fff"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </button>
    </div>
  );
}

export default C2wPlacements;
